import React from "react";

export function FormatHint({ children }) {
  return (
    <div className="flex flex-row">
      <div className="text-secondary italic text-sm pb-2">
        {children}
      </div>
    </div>
  );
}
